import React from "react";
import { dateFormat, hourFormat } from "functions/functions";
import "./listaEventos.sass";

export default function ListaEventos({ dataFiltradaEnVivo, numCards, targetB }) {
    return (
        <ul className="ul-eventos">
            {dataFiltradaEnVivo.map((item, indice) =>
                (numCards && (indice + 1 > numCards)) &&
                <li className="li-eventos" key={indice}>
                    <a href={item.url} target={String(targetB) === "true" ? "_blank" : "_top"} rel="noreferrer">

                        {(item?.is_live) ? <div className="status-live"></div> : <div className="status-off"></div>}

                        <div className="li-date">
                            <p className="bold dateCopy">{dateFormat(item.session_start_time_utc)} <span className="separador">, &nbsp;</span> </p>

                            <span className="bold">{hourFormat(item.session_start_time_utc)} - {hourFormat(item.session_end_time_utc)} hrs </span>
                        </div>
                        <div className="li-text">
                            <p>
                                <span className="">{item.discipline}</span> | {String(item.session_title).length === 0 ? item.session_title_editorial : item.session_title}
                            </p>
                        </div>
                    </a>
                </li>
            )}
        </ul>
    )
}